import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import MediaHeader from './components/MediaHeader';
import MediaContent from './components/MediaContent';

export default function Media() {
  const location = useLocation();

  usePageMeta(
    'Media | Keaton Brown — Watch Performances & Recordings',
    'Watch and listen to Keaton Brown\'s performance recordings, recital excerpts, concert work, and opera highlights. Based in Houston, Texas.'
  );

  return (
    <main>
      <MediaHeader />
      <MediaContent />
    </main>
  );
}